var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File icons 24px/PDF",
    clipPath: "url(#clip0_62488_125524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V15H17C15.8954 15 15 15.8954 15 17V21H5C3.89543 21 3 20.1046 3 19V5ZM21 17C21 19.2091 19.2091 21 17 21V17H21ZM8.991 7.948C8.991 6.814 8.123 6.1 6.758 6.1H4.399V11H6.051V9.796H6.758C8.123 9.796 8.991 9.082 8.991 7.948ZM7.325 7.948C7.325 8.305 7.108 8.522 6.653 8.522H6.051V7.374H6.653C7.108 7.374 7.325 7.591 7.325 7.948ZM9.53279 6.1V11H11.9478C13.5858 11 14.7128 10.069 14.7128 8.55C14.7128 7.031 13.5858 6.1 11.9478 6.1H9.53279ZM11.8778 9.712H11.1848V7.388H11.8778C12.5708 7.388 13.0468 7.801 13.0468 8.55C13.0468 9.299 12.5708 9.712 11.8778 9.712ZM16.968 7.346H19.299V6.1H15.316V11H16.968V9.432H19.012V8.186H16.968V7.346Z",
    fill: "#EF151A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62488_125524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.76949a5ac09c7ab4af3f72d6b3be1df3.svg";
export { ForwardRef as ReactComponent };